export default __webpack_public_path__ + "static/media/v-health-logo.b7089998.png";